// keyValue
export const SET_STATE = 'SET_STATE';
// ui
export const SET_UI_STATE = 'ui/SET_UI_STATE';
// auth
export const LOGOUT_REQUEST = 'auth/LOGOUT_REQUEST';
export const INITIALIZE_AUTHORIZED_REQUEST = 'auth/INITIALIZE_AUTHORIZED_REQUEST';
// other
export const CLEAR_ALL_REDUCERS = 'CLEAR_ALL_REDUCERS';
